import React from "react";

const UpdateVoidReason = () => {
  return <div>update</div>;
};

export default UpdateVoidReason;
